import React, {useEffect, useState} from 'react';
import {Container} from 'reactstrap';
import {connect} from 'react-redux';
import {activeInvoiceOnlineIFrame} from '../PersonalAreaInvoicesBlock/invoiceComponentBlockSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import Config from '../../../Config';
import ProviderManager from '../../../provider/providerManager';
import { reportDWH } from '../SelfCareInvoicesBlock/SelfCareInvoiceBlockSlice';
import {isMobile} from 'react-device-detect';

const InvoiceOnlineIFrameWrapperComponent = (props) => {
  const [url, setUrl] = useState('');
  const [type, setType] = useState('Cellcom');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    const getBillUrl = async (banPsid,invoiceSourceType) => {
      try {
        props.showAppLoader();
        const result = await ProviderManager.getProviderData('getInvoiceBillUrl', [banPsid]);
        const billUrl = result?.Body?.invoiceBillUrl;
        setUrl(billUrl);
        setType(invoiceSourceType);
        props.hideAppLoader();
      } catch (error) {
        console.error('Error fetching provider data:', error);
        window.location.replace(Config.lobbyUrl);
      }
    };
    if(props?.isAuthenticateFinish){

      const getSessionStorage = () => {
        const data = sessionStorage.getItem('invoiceIframeData');
        if (data) {
          sessionStorage.removeItem('invoiceIframeData');
          return JSON.parse(data);
        }
        return null;
      };

      const sessionData = getSessionStorage();
      const banPsid = sessionData && sessionData.banPsid;
      const invoiceSourceType = sessionData && sessionData.invoiceSourceType;

      if ((banPsid && invoiceSourceType) && props.isFullAuthenticated) {
        props.reportDWH({ actionType: 'Invoice Page', status: 'Completed', messageText: 'Invoice Page Displayed' , param1 : banPsid});
        getBillUrl(banPsid,invoiceSourceType);

      } else if (props.props.activeInvoiceURL) {
        setUrl(props.props.activeInvoiceURL);
        setType(props.props.activeInvoiceUrlType);
      } else {
        const query = new URLSearchParams(window.location.search);
        const guidId = query.get('id');
        let url;

        if (guidId) {
          url = `${props.iContent.cellcomInvoicesDomainUrl?.value}${guidId}`;
          setUrl(url);
        } else {
          if (props.isFullAuthenticated) {
            window.location.replace(Config.lobbyUrl);
          }
        }
      }
    }

  }, [props?.isAuthenticateFinish]);

  useEffect(() => {
    if (url.trim() != '') {
      window.addEventListener(
        'message',
        function (e) {
          $('.invoice-online-iframe').height(e.data.height);
          $('.body-wrapper').height(e.data.height);
        },
        false
      );

      props.activeInvoiceOnlineIFrame('');
      document.querySelector('.invoice-online-iframe').onload = function () {
        setTimeout(() => {
          props.hideAppLoader();
          setIsLoading(false);
        }, 300);
      };
    }
  }, [url]);

  return (
    <Container className={`${isMobile ? 'pl-0 pr-0' : ''} invoice-online-iframe-wrapper ${isLoading ? 'isLoading' : ''}`}>
      <iframe
        className={` ${isMobile ? 'mobile' : ''} invoice-online-iframe ${type != 'Cellcom' ? 'netvision' : ''}`}
        src={url}
        title='invoice online'
        frameBorder='0'
        scrolling='yes'
        width='100%'
        height='100%'></iframe>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    props: state.invoices,
    isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
    isAuthenticateFinish: state.authentication?.isAuthenticateFinish
  };
};

const mapDispatchToProps = {
  activeInvoiceOnlineIFrame,
  showAppLoader,
  hideAppLoader,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceOnlineIFrameWrapperComponent);
